import React, { useState } from "react";
import * as S from "./login.style.ts";
import Loading from "../../components/Loading/Loading.tsx";
import { useNavigate } from "react-router-dom";
import { loggedInHomepage } from "../../functions/helper.ts";
import { useAuth } from "../../context/AuthContext.tsx";
import Button from "../../components/Button/Button.tsx";
import SignUpModal from "../../components/SignUpModal/SignUpModal.tsx";

const Login = () => {
  const { isLoading, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const [loginModal, setLoginModal] = useState<boolean>(false);

  if (isLoading) {
    return <Loading isText />;
  }

  if (isAuthenticated) {
    navigate(loggedInHomepage(undefined));
  }

  return (
    <>
      <S.Wrapper>
        <S.Section>
          <S.Catchphrase>
            <h1>Know exactly where your money stands and how long it lasts.</h1>
            <div className="subText">
              A simple budget and cash-flow plan. Steady paycheck or income that
              arrives in lumps, you always know your runway and what&apos;s safe
              to spend.
            </div>
            <Button buttonSize="large" handleClick={() => setLoginModal(true)}>
              Get Started
            </Button>
          </S.Catchphrase>
          <img
            src="/images/homepage/header.png"
            width="auto"
            height="auto"
            alt="laptop and iphone of the monthly expense page"
            className="device"
          />
        </S.Section>
      </S.Wrapper>
      <SignUpModal
        isOpen={loginModal}
        setIsOpen={setLoginModal}
        loginMode="signup"
      />
    </>
  );
};

export default Login;
